module["exports"] = [
  "0#-#######",
  "02-########",
  "09##-######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/phone_number/formats.js
// module id = 1525
// module chunks = 0